module.exports = __webpack_public_path__ + "static/cms-b87330533d5f634be717d980b0870812.png";